<div class="flex flex-col gap-4 text-center rounded-md p-4 border-solid border-4 border-toyotaRed">
  <span class="font-semibold text-lg">
    Die Bearbeitung Ihrer Einwilligung ist nicht möglich.
  </span>
  <span>
    Bitte melden Sie sich bei der {{ brand.name }} Kundenbetreuung bevorzugt telefonisch unter
    <a
      [href]="'tel:' + legalEntity.phone"
      class="cursor-pointer underline"
    >
      {{legalEntity.phone}}
    </a>
    oder per E-Mail
    <a
      [href]="'mailto:' + legalEntity.email"
      class="cursor-pointer underline"
    >
      {{legalEntity.email}}
    </a>
  </span>
</div>
